import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";
import { AbstractParser } from "../../parser";
import { parseProductTypes } from "./product-management-parse-funtions";

export class ProductTypesParser extends AbstractParser<ProductType[]> {
  public parse(payload: any): ProductType[] {
    return parseProductTypes(payload);
  }
}
